// src\routes\agentRoutes.tsx
import { lazy, Suspense } from "react";
import Loader from "../components/CustomLoader";
import { Navigate, RouteObject } from "react-router-dom";
import { AgentLayout, } from "../layouts";

const AgentDashboard = lazy(() => import("../pages/Agent/Dashbaord/Dashboard"));
const Tickets = lazy(() => import("../pages/Agent/Ticket/TicketList"));
const NotificationList = lazy(() => import("../pages/Common/NotificationList"));
const ReplyTicket = lazy(() => import("../pages/Agent/Ticket/ticketDetails"));
const AddTicket = lazy(() => import("../pages/Agent/Ticket/AddTicket"));
const Scripts = lazy(() => import("../pages/Agent/Scripts"));
const CustomerInquiryList = lazy(() => import("../pages/Agent/CustomerInquiryList"));
const CrmCustomerList = lazy(() => import("../pages/Agent/Crm/Customers/CustomerList"));
const CrmCustomerAddUpdate = lazy(() => import("../pages/Agent/Crm/Customers/AddEditCustomer"));
const CustomerViewDetails = lazy(() => import("../pages/Agent/Crm/Customers/CustomerViewDetails"));
const CrmSalesAdd = lazy(() => import("../pages/Agent/Crm/Sales/AddDeal"));
const PerfromanceReport = lazy(() => import("../pages/Agent/Crm/Sales/PerfromanceReport"));
const AgentAttendance = lazy(() => import("../pages/Agent/Attendance"));
const Leads = lazy(() => import("../pages/Agent/Crm/SalesLead/Leads"));
const LeadsAddUpdate = lazy(() => import("../pages/Agent/Crm/SalesLead/LeadsAddUpdate"));
const DealConversation = lazy(() => import("../pages/Agent/Crm/Sales/DealConversation"));
const SalesQuery = lazy(() => import("../pages/Agent/Crm/SalesQuery/SalesQuery"));
const CrmSales = lazy(() => import("../pages/Agent/Crm/Sales/Sales"));
const MySchedule = lazy(() => import("../pages/Agent/Schedule/MySchedule"));
const ShiftSwaps = lazy(() => import("../pages/Agent/Schedule/ShiftSwaps"));
const LeaveRequest = lazy(() => import("../pages/Agent/LeaveRequest/LeaveRequest"));

const EmailTempeleteCreate = lazy(() => import("../pages/SuperVisor/Marketing/EmailTempelete/EmailTempeleteCreate"));
const EmailTempelteList = lazy(() => import("../pages/SuperVisor/Marketing/EmailTempelete/EmailTempelteList"));
const ProspectList = lazy(() => import("../pages/SuperVisor/Marketing/Prospects/ProspectList"));
const CreateProspect = lazy(() => import("../pages/SuperVisor/Marketing/Prospects/CreateProspect"));
const SegmentList = lazy(() => import("../pages/SuperVisor/Marketing/Segments/SigementList"));
const CreateSegment = lazy(() => import("../pages/SuperVisor/Marketing/Segments/SegmentAddEdit"));
const CampaignList = lazy(() => import("../pages/SuperVisor/Marketing/Campaings/CampaingList"));
const CreateCampaign = lazy(() => import("../pages/SuperVisor/Marketing/Campaings/AddEdit/CreateCampaing"));
const FacebookPostThreadsList = lazy(() => import("../pages/Agent/FacebookPostThreads/FacebookPostThreadsList"));
const FacebookPostThreadDetails = lazy(() => import("../pages/Agent/FacebookPostThreads/FacebookPostThreadDetails"));

// Reuse the shared (config-driven) conversation pages built for the supervisor — APIs are identical.
const FacebookConversationsList = lazy(() => import("../pages/SuperVisor/FacebookConversations/FacebookConversationsList"));
const FacebookConversationDetails = lazy(() => import("../pages/SuperVisor/FacebookConversations/FacebookConversationDetails"));
const InstagramConversationsList = lazy(() => import("../pages/SuperVisor/InstagramConversations/InstagramConversationsList"));
const InstagramConversationDetails = lazy(() => import("../pages/SuperVisor/InstagramConversations/InstagramConversationDetails"));
const WhatsappConversationsList = lazy(() => import("../pages/SuperVisor/Whatsapp/Conversations/WhatsappConversationsList"));
const WhatsappConversationDetails = lazy(() => import("../pages/SuperVisor/Whatsapp/Conversations/WhatsappConversationDetails"));
const FacebookTemplatesList = lazy(() => import("../pages/SuperVisor/SocialTemplates/FacebookTemplatesList"));
const FacebookTemplateEdit = lazy(() => import("../pages/SuperVisor/SocialTemplates/FacebookTemplateEdit"));
const InstagramTemplatesList = lazy(() => import("../pages/SuperVisor/SocialTemplates/InstagramTemplatesList"));
const InstagramTemplateEdit = lazy(() => import("../pages/SuperVisor/SocialTemplates/InstagramTemplateEdit"));
const AgentProfile = lazy(() => import("../pages/Agent/Profile"));
const TicketCategories = lazy(() => import("../pages/Agent/Ticket/TicketCategories"));
const TicketSubCategories = lazy(() => import("../pages/Agent/Ticket/TicketSubCategories"));
const TicketSubSubCategories = lazy(() => import("../pages/Agent/Ticket/TicketSubSubCategories"));

const AvailableWhatsappTempelate = lazy(() => import("../pages/SuperVisor/Whatsapp/AvailableWhatsappTempelate"));
const EditWhatsappTempelate = lazy(() => import("../pages/SuperVisor/Whatsapp/EditwhatsAppTempelate"));

const withSuspense = (Component: React.FC) => (
  <Suspense fallback={<Loader force={true} />}>
    <Component />
  </Suspense>
);


export const agentRoutes: RouteObject[] = [
  {
    path: "/",
    element: <AgentLayout />,
    children: [
      // { path: "", element: <Navigate to="/dashboard" /> },
      { path: "dashboard", element: withSuspense(AgentDashboard) },

      { path: "tickets", element: withSuspense(Tickets) },
      { path: "ticket-categories", element: withSuspense(TicketCategories) },
      { path: "ticket-sub-categories", element: withSuspense(TicketSubCategories) },
      { path: "ticket-sub-sub-categories", element: withSuspense(TicketSubSubCategories) },
      { path: "tickets/:id", element: withSuspense(ReplyTicket) },
      { path: "/tickets/add", element: withSuspense(AddTicket) },
      { path: "customer-query", element: withSuspense(CustomerInquiryList) },
      { path: "attendance", element: withSuspense(AgentAttendance) },

      { path: "/crm/customers", element: withSuspense(CrmCustomerList) },
      { path: "/crm/customers/add", element: withSuspense(CrmCustomerAddUpdate) },
      { path: "/crm/customers/edit/:id", element: withSuspense(CrmCustomerAddUpdate) },
      { path: "/crm/customers/details/:id", element: withSuspense(CustomerViewDetails) },

      { path: "/crm/sales", element: withSuspense(CrmSales) },
      { path: "/crm/sales/add-deal", element: withSuspense(CrmSalesAdd) },
      { path: "/crm/sales/edit-deal", element: withSuspense(CrmSalesAdd) },
      { path: "/crm/sales-query", element: withSuspense(SalesQuery) },
      { path: "/crm/sales/conversation", element: withSuspense(DealConversation) },
      { path: "/crm/performance-report", element: withSuspense(PerfromanceReport) },
      { path: "/crm/leads", element: withSuspense(Leads) },
      { path: "/crm/leads/add", element: withSuspense(LeadsAddUpdate) },
      { path: "/crm/leads/edit", element: withSuspense(LeadsAddUpdate) },
      { path: "scripts", element: withSuspense(Scripts) },

      { path: "notifications", element: withSuspense(NotificationList) },


      { path: "/work-schedule", element: withSuspense(MySchedule) },
      { path: "/shift-swaps", element: withSuspense(ShiftSwaps) },
      { path: "/leave-requests", element: withSuspense(LeaveRequest) },

      { path: "/email/template/create", element: withSuspense(EmailTempeleteCreate) },
      { path: "/email/template/update", element: withSuspense(EmailTempeleteCreate) },
      { path: "/email/templates", element: withSuspense(EmailTempelteList) },
      { path: "/segments", element: withSuspense(SegmentList) },
      { path: "/segment/add", element: withSuspense(CreateSegment) },
      { path: "/segment/update", element: withSuspense(CreateSegment) },

      { path: "/prospects", element: withSuspense(ProspectList) },
      { path: "/prospect/add", element: withSuspense(CreateProspect) },
      { path: "/prospect/edit", element: withSuspense(CreateProspect) },

      { path: "/campaigns", element: withSuspense(CampaignList) },
      { path: "/campaign/create", element: withSuspense(CreateCampaign) },
      { path: "/campaign/update", element: withSuspense(CreateCampaign) },

      { path: "/facebook-post-threads", element: withSuspense(FacebookPostThreadsList) },
      { path: "/facebook-post-threads/:threadId", element: withSuspense(FacebookPostThreadDetails) },

      { path: "/facebook-conversations", element: withSuspense(FacebookConversationsList) },
      { path: "/facebook-conversations/:conversationId", element: withSuspense(FacebookConversationDetails) },
      { path: "/instagram-conversations", element: withSuspense(InstagramConversationsList) },
      { path: "/instagram-conversations/:conversationId", element: withSuspense(InstagramConversationDetails) },

      // { path: "settings/whatsapp", element: withSuspense(AvailableWhatsappTempelate) },
      // { path: "settings/whatsapp/template/edit", element: withSuspense(EditWhatsappTempelate) },
      { path: "/whatsapp-conversations", element: withSuspense(WhatsappConversationsList) },
      { path: "/whatsapp-conversations/:conversationId", element: withSuspense(WhatsappConversationDetails) },

      // { path: "/facebook-templates", element: withSuspense(FacebookTemplatesList) },
      // { path: "/facebook-templates/edit", element: withSuspense(FacebookTemplateEdit) },
      // { path: "/instagram-templates", element: withSuspense(InstagramTemplatesList) },
      // { path: "/instagram-templates/edit", element: withSuspense(InstagramTemplateEdit) },

      { path: "profile", element: withSuspense(AgentProfile) },
    ],
  },
];
